export default __webpack_public_path__ + "static/media/dummy-img.e8ed28d5.svg";